export default {
    title: 'Settlements',
    addSettlementShortLabel: 'New',
    addSettlement: 'Create settlement',
    filterLabel: 'Filter by',
    resultLabel: '{result} result | {result} results',
    lastUpdateLabel: 'Last update: {datetime}',
    orderLabel: 'Order by',
    loadingDataLabel: 'Loading authorizations',
    emptyDataLabel: 'No results found',
    tryAgainLabel: 'Try again with another term or',
    paginationSizeLabel: 'Results/page',
    cleanFilters: 'clean the filters',
    filtersAppliedLabel: 'applied',
    sponsorSettlement: 'In process',
    status: {
        inProgress: 'In progress',
        completed: 'Pagado',
        sentToSponsor: 'Sent',
        rejectedBySponsor: 'Rejected',
        approvedBySponsor: 'Settled',
        error: 'Error'
    },
    filters: {
        status: 'Status',
        sponsor: 'Sponsor',
        from: 'From',
        to: 'To',
        searchCode: 'Search by ID',
        dateRange: 'Date range',
    },
    settlementGrid: {
        code: 'Settlement ID',
        createdAt: 'Created at',
        sponsor: 'Sponsor',
        amount: 'Amount',
        authorizations: 'Authorizations',
        status: 'Status',
        medicalAccount: "Medical account"
    },
    sponsors: {
        DO: {
            humano: 'Humano Seguros',
            universal: 'ARS Universal',
            primera: 'ARS Primera'
        }
    },
    creation: {
        success: 'The settlement was created successfully.',
        error: 'An error occurred when creating the settlement.'
    },
    documentation: {
        complete: "Complete",
        incomplete: "({uploaded}/{total}) Docs",
        incompleteMessage: "Incomplete documentation"
    },
    documentType: {
        invoiceFile: "Invoice document",
        creditNoteFile: "Credit note file",
        debitNoteFile: "Debit note file"
    }
}
